/* eslint-disable camelcase */
import { bool, func, shape, string } from "prop-types";

import React from "react";

import Button from "pages/_components/Button";
import Dropdown from "pages/_components/Dropdown";
import * as i18nUtils from "util/i18n";
import { routerActions } from "react-router-redux/actions";
import { actions as cedipActions } from "reducers/cedip";
import Head from "pages/_components/Head";
import ContextMenu from "pages/_components/ContextMenu";

function DetailHeadTitle({
    dispatch,
    cedip: { cedipId, numeroCertificado },
    isDesktop,
    fetchingDownload,
    handleClickDownload,
    handleBack,
    embeddedInV3Shell,
}) {
    const handleClickManageCedip = () => {
        dispatch(cedipActions.handleClickManageCedip(cedipId));
        dispatch(routerActions.push("/cedip"));
    };

    const maskCedipId = (id) => {
        const maskedPart = "***";
        const visiblePart = id.slice(-7);
        return maskedPart + visiblePart;
    };

    const maskedCedipId = maskCedipId(cedipId);

    const dropDownContextMenuMobile = () => (
        <div className="toolbar-item">
            <ContextMenu
                isDesktop={isDesktop}
                color="white"
                items={[
                    {
                        label: "global.download",
                        onClick: () => handleClickDownload("pdf"),
                        icon: "SendDown",
                    },
                ]}
            />
        </div>
    );

    const centerElementMobile = () => (
        <div className="cedip__detail-head-mobile">
            <h1 className="cedip__detail-title">{cedipId}</h1>
            <p className="cedip__detail-subtitle">
                {`${i18nUtils.get("deposits.information.certificate").toUpperCase()}  Nº ${numeroCertificado}`}
            </p>
            <p className="cedip__detail-subtitle">
                {`${i18nUtils.get("deposits.information.certificate.cedip").toUpperCase()}  ${maskedCedipId}`}
            </p>
        </div>
    );

    const rightContent = () => (
        <div className="d-flex gap-2">
            <Button
                onClick={handleClickManageCedip}
                className="min-width-14"
                label="deposits.cedip.manageCedip"
                bsStyle="primary"
                imageStyle="mr-2"
            />
            <Dropdown
                image="images/download_bold.svg"
                imageStyle="mr-2"
                buttonClass="min-width-14"
                label="global.download"
                bsStyle="outline"
                fetching={fetchingDownload}
                pullDown>
                <Button
                    onClick={() => handleClickDownload("pdf")}
                    label="accounts.pdfFile"
                    className="dropdown__item-btn"
                    bsStyle="link"
                />
            </Dropdown>
        </div>
    );

    if (!isDesktop && embeddedInV3Shell) {
        return null;
    }

    if (isDesktop) {
        return (
            <div className="cedip__detail-head">
                <Head onBack={handleBack} navStyle="default pl-0" headerClassName="align-items-center d-flex" />
                <Head
                    navStyle="default pl-0"
                    titleText={cedipId}
                    handleClickMessage="global.download"
                    rightContent={() => rightContent()}
                />
                <p className="cedip__detail-subtitle">
                    {`${i18nUtils.get("deposits.information.certificate").toUpperCase()}  Nº ${numeroCertificado}`}
                </p>
                <p className="cedip__detail-subtitle">
                    {`${i18nUtils.get("deposits.information.certificate.cedip").toUpperCase()}  ${maskedCedipId}`}
                </p>
            </div>
        );
    }

    return (
        <Head
            headerClassName="blue-main-header-mobile"
            titleClassName="w-100 align-center"
            onBack={handleBack}
            centerElement={centerElementMobile}
            rightContent={dropDownContextMenuMobile}
        />
    );
}

DetailHeadTitle.propTypes = {
    dispatch: func.isRequired,
    isDesktop: bool.isRequired,
    cedip: shape({
        cedipId: string.isRequired,
        numeroCertificado: string.isRequired,
    }).isRequired,
    fetchingDownload: bool.isRequired,
    handleClickDownload: func.isRequired,
    handleBack: func.isRequired,
    embeddedInV3Shell: bool,
};

DetailHeadTitle.defaultProps = {
    embeddedInV3Shell: false,
};

export default DetailHeadTitle;
